<div class="analysis-container">
  <div class="analysis-info">
    <div class="analysis-header">
      <ng-container *ngIf="url; else noLink">
        <a class="item-name" [routerLink]="url" [title]="displayName">
          {{ displayName }}
        </a>
      </ng-container>
      <ng-template #noLink>
        <div class="item-name" [title]="displayName">
          {{ displayName }}
        </div>
      </ng-template>

      <div class="analysis-status" [ngClass]="statusClass">{{ displayStatus }}</div>
    </div>
    <div class="analysis-body">
      <div class="created-by-user-name">{{ analysis.UserName }}</div>
      <div class="app-name" i18n>{{ analysis.Application }}</div>
      <div class="created-on">{{ analysis.CreatedOn | date: 'MMM d, y, h:mm a' }}</div>
    </div>
  </div>

  <div class="progress-container">
    <div i18n>Total Progress</div>
    <mat-progress-bar mode="determinate" [value]="progressValue" color="accent" i18n>Total Progress</mat-progress-bar>
  </div>
</div>
